<div class="about_container">
  <div class="about">
    <div class="about_wrapper">
      <div class="about_content" style="justify-content: space-between; text-align: left;">
        <div>
          <div class="greeting">
            <hr style="width: 15px; display: inline-block; vertical-align: middle; border-top: 3px solid #5b5d6b;">
            <span style="font-size: small; color: #5b5d6b; padding-left: 5px;">
              HELLO
            </span>
          </div>
          <h1 class="intro">I'm <span style="color: #022c67; font-weight: 500;"> Huzaifa </span> Anjum </h1>
          <h2 class="intro_message">
            I'm a <br>
            <span id="typeText">
            </span>
          </h2>
          <h4 class="short_description">
            Fuelled by a passion for developing web
            applications and designing compelling products, I have deep
            desire to excel and continuously improve my craft.
          </h4>
          <div>
            <a (click)="downloadResume()" class="links linkedIn btn" style="color: #fff;">
              <mat-icon style="height: 20px;
              width: 20px;
              vertical-align: middle;
              font-size: 20px;">file_download</mat-icon> Resume
            </a>
            <a style="color: white;" class="links contact btn" (click)="scrollToContact()">
              Contact
            </a>
          </div>
        </div>
        <div class="scroll_down_container">
          <mat-icon [inline]="true" class="flat_arrow">trending_flat</mat-icon>
          <span>Scroll down</span>
        </div>
      </div>
    </div>
    <div class="about_content_img_container" style="display: flex; justify-content: center; align-items: center;">
      <img src="../../../../assets/img/portfolioimg4.png" alt="me">
    </div>
  </div>
  <div class="custom_footer">
    <div style="padding: 20px 0;">
      <p style="margin-bottom: 0; font-size: large;">
        Social
      </p>
    </div>

    <div class="social_icons_container">
      <a class="social_icons" href="https://www.facebook.com/huzaifa.rock.75">
        <i class="fa fa-facebook-f" style="color: #022c67;"></i>
      </a>
      <a class="social_icons" href="https://twitter.com/_huzaifaanjum_?s=03">
        <i class="fa fa-twitter" style="color: #022c67"></i>
      </a>
      <a class="social_icons"
        href="https://in.linkedin.com/in/huzaifa-anjum-90b117133?trk=public_profile_browsemap_mini-profile_title">
        <i class="fa fa-linkedin" style="color: #022c67"></i>
      </a>
      <a class="social_icons" href="https://www.instagram.com/_huzaifaanjum_">
        <i class="fa fa-instagram" style="color: #022c67;"></i>
      </a>
      <a class="social_icons" href="https://open.spotify.com/user/hfyhrwd4gyaut1lpozi6gwys4?si=AwsN2S3uTEeHWGsMDArZug">
        <i class="fa fa-spotify" style="color: #022c67;"></i>
      </a>
    </div>
  </div>
</div>
